import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, {
  Path,
  Defs,
  LinearGradient,
  Stop,
  Rect,
  G,
  ClipPath,
  Pattern,
  RadialGradient
} from "react-native-svg";

export default function GCalIcon(props) {
  const width = props.width || 60;
  const height = props.height || 60;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg width={width} height={height} viewBox="0 0 60 60" fill="none">
        <G clipPath="url(#clip0_gcal)">
          <Path
            d="M52.3078 0H7.69248C5.14244 0 3.07703 2.06541 3.07703 4.61536L3.16549 33.8461H56.9232V4.61536C56.9233 2.06541 54.8579 0 52.3078 0Z"
            fill="#C2C2C2"
          />
          <Rect
            x="-4.4248"
            y="6.1543"
            width="68.8476"
            height="33.8759"
            fill="url(#pattern0_gcal)"
          />
          <Path
            d="M55.3846 9.23145H4.61536C2.06541 9.23145 0 11.2969 0 13.8469C0 14.0623 0.0154193 14.2738 0.0422954 14.4776L3.07688 33.8468H56.923L59.9576 14.4776C59.9846 14.2699 59.9999 14.0584 59.9999 13.8469C60 11.2969 57.9346 9.23145 55.3846 9.23145Z"
            fill="#3367D6"
          />
          <Path
            opacity="0.5"
            d="M55.3846 9.23145H4.61536C2.06541 9.23145 0 11.2969 0 13.8469C0 14.0623 0.0154193 14.2738 0.0422954 14.4776L3.07688 33.8468H56.923L59.9576 14.4776C59.9846 14.2699 59.9999 14.0584 59.9999 13.8469C60 11.2969 57.9346 9.23145 55.3846 9.23145Z"
            fill="#2A56C6"
          />
          <Path
            d="M58.4501 53.5265L56.9231 33.8457H3.07697L1.55012 53.5265C1.54245 53.6342 1.53857 53.7381 1.53857 53.8457C1.53857 56.3958 3.60398 58.4611 6.15394 58.4611H53.8462C56.3963 58.4611 58.4616 56.3957 58.4616 53.8457C58.4616 53.7381 58.4578 53.6342 58.4501 53.5265Z"
            fill="#4285F4"
          />
          <Path
            d="M3.07703 33.8457L27.6924 58.4611H58.4617V33.8457H3.07703Z"
            fill="url(#paint0_linear_gcal)"
          />
          <Path
            d="M4.61536 9.61509H55.3846C57.8807 9.61509 59.9115 11.5997 59.9923 14.0766C59.9962 13.9997 60 13.9228 60 13.8458C60 11.2958 57.9346 9.23047 55.3846 9.23047H4.61536C2.06541 9.23047 0 11.2959 0 13.8459C0 13.9228 0.00387636 13.9998 0.00766658 14.0767C0.0884671 11.5997 2.11925 9.61509 4.61536 9.61509Z"
            fill="white"
            fillOpacity="0.2"
          />
          <Path
            d="M53.8462 58.0768H6.15394C3.65782 58.0768 1.62704 56.0921 1.54624 53.6152C1.54236 53.6922 1.53857 53.7691 1.53857 53.846C1.53857 56.396 3.60398 58.4614 6.15394 58.4614H53.8462C56.3963 58.4614 58.4616 56.396 58.4616 53.846C58.4616 53.7691 58.4577 53.6922 58.4539 53.6152C58.3731 56.0921 56.3424 58.0768 53.8462 58.0768Z"
            fill="#1A237E"
            fillOpacity="0.2"
          />
          <Path
            d="M52.3078 0H7.69248C5.14244 0 3.07703 2.06541 3.07703 4.61536V4.98078C3.08857 2.44228 5.1501 0.384621 7.69248 0.384621H52.3079C54.8579 0.384621 56.9233 2.45003 56.9233 4.99999V4.61536C56.9233 2.06541 54.8579 0 52.3078 0Z"
            fill="white"
            fillOpacity="0.2"
          />
          <Path
            d="M25.4848 33.5157C27.2348 32.7926 29.4886 30.8695 29.4886 27.9734C29.4886 23.5118 26.6232 20.7695 21.7963 20.7695C17.4963 20.7695 14.0309 23.5849 13.9694 27.6926H17.0925C17.1387 25.2926 18.7617 23.3196 21.7925 23.3196C24.7118 23.3196 26.3579 24.8388 26.3579 27.9042C26.3579 30.9696 24.0118 32.385 21.1503 32.385C20.0271 32.385 18.9695 32.385 18.9695 32.385V34.8312C18.9695 34.8312 20.1772 34.8312 21.1503 34.8312C25.3579 34.8312 26.7425 37.0158 26.7425 39.5504C26.7425 42.8658 24.7272 44.3965 21.8079 44.3965C19.2657 44.3965 16.9503 43.0389 16.881 40.0042H13.7349C13.8695 44.8926 17.9849 46.9273 21.8079 46.9273C26.2233 46.9273 29.8656 44.3542 29.8656 39.4811C29.8733 35.5503 27.0732 33.981 25.4848 33.5157ZM43.3386 20.7695L34.2309 24.0388V26.9772L40.7694 24.7926V46.9233H43.8463V20.7695H43.3386Z"
            fill="#E1E1E1"
          />
          <G opacity="0.5">
            <Path
              opacity="0.5"
              d="M25.4848 33.5157C27.2348 32.7926 29.4886 30.8695 29.4886 27.9734C29.4886 23.5118 26.6232 20.7695 21.7963 20.7695C17.4963 20.7695 14.0309 23.5849 13.9694 27.6926H17.0925C17.1387 25.2926 18.7617 23.3196 21.7925 23.3196C24.7118 23.3196 26.3579 24.8388 26.3579 27.9042C26.3579 30.9696 24.0118 32.385 21.1503 32.385C20.0271 32.385 18.9695 32.385 18.9695 32.385V34.8312C18.9695 34.8312 20.1772 34.8312 21.1503 34.8312C25.3579 34.8312 26.7425 37.0158 26.7425 39.5504C26.7425 42.8658 24.7272 44.3965 21.8079 44.3965C19.2657 44.3965 16.9503 43.0389 16.881 40.0042H13.7349C13.8695 44.8926 17.9849 46.9273 21.8079 46.9273C26.2233 46.9273 29.8656 44.3542 29.8656 39.4811C29.8733 35.5503 27.0732 33.981 25.4848 33.5157ZM43.3386 20.7695L34.2309 24.0388V26.9772L40.7694 24.7926V46.9233H43.8463V20.7695H43.3386Z"
              fill="#C2C2C2"
            />
          </G>
          <Path
            d="M25.4848 33.5157C27.2348 32.7926 29.4886 30.8695 29.4886 27.9734C29.4886 23.5118 26.6232 20.7695 21.7963 20.7695C17.4963 20.7695 14.0309 23.5849 13.9694 27.6926H17.0925C17.1387 25.2926 18.7617 23.3196 21.7925 23.3196C24.7118 23.3196 26.3579 24.8388 26.3579 27.9042C26.3579 30.9696 24.0118 32.385 21.1503 32.385C20.0271 32.385 18.9695 32.385 18.9695 32.385V34.8312C18.9695 34.8312 20.1772 34.8312 21.1503 34.8312C25.3579 34.8312 26.7425 37.0158 26.7425 39.5504C26.7425 42.8658 24.7272 44.3965 21.8079 44.3965C19.2657 44.3965 16.9503 43.0389 16.881 40.0042H13.7349C13.8695 44.8926 17.9849 46.9273 21.8079 46.9273C26.2233 46.9273 29.8656 44.3542 29.8656 39.4811C29.8733 35.5503 27.0732 33.981 25.4848 33.5157ZM43.3386 20.7695L34.2309 24.0388V26.9772L40.7694 24.7926V46.9233H43.8463V20.7695H43.3386Z"
            fill="#EEEEEE"
          />
          <Path
            d="M16.7349 9.23048L13.7542 6.24594L17.0157 2.98438L23.2657 9.23048H16.7349Z"
            fill="url(#paint1_linear)"
          />
          <Path
            d="M15.3849 6.92307C16.6594 6.92307 17.6926 5.88986 17.6926 4.61534C17.6926 3.34082 16.6594 2.30762 15.3849 2.30762C14.1104 2.30762 13.0771 3.34082 13.0771 4.61534C13.0771 5.88986 14.1104 6.92307 15.3849 6.92307Z"
            fill="#EEEEEE"
          />
          <Path
            d="M15.3849 2.69419C16.5964 2.69419 17.5848 3.62495 17.6811 4.80956C17.6887 4.74418 17.6926 4.68268 17.6926 4.6173C17.6926 3.34421 16.658 2.30957 15.3849 2.30957C14.1118 2.30957 13.0771 3.34421 13.0771 4.6173C13.0771 4.68268 13.081 4.74418 13.0887 4.80956C13.1849 3.62495 14.1734 2.69419 15.3849 2.69419Z"
            fill="white"
            fillOpacity="0.4"
          />
          <Path
            d="M17.6811 4.80762C17.5849 5.99223 16.5926 6.92299 15.3849 6.92299C14.1772 6.92299 13.1849 5.99223 13.0887 4.80762C13.081 4.873 13.0771 4.9345 13.0771 4.99988C13.0771 6.27297 14.1118 7.30761 15.3849 7.30761C16.658 7.30761 17.6926 6.27297 17.6926 4.99988C17.6926 4.9345 17.6887 4.873 17.6811 4.80762Z"
            fill="#212121"
            fillOpacity="0.1"
          />
          <Path
            d="M57.3078 33.8467H2.69238V34.2313H57.3078V33.8467Z"
            fill="white"
            fillOpacity="0.05"
          />
          <Path
            d="M57.3078 33.4619H2.69238V33.8465H57.3078V33.4619Z"
            fill="#1A237E"
            fillOpacity="0.05"
          />
          <Path
            d="M45.9657 9.23048L42.9849 6.24594L46.2464 2.98438L50.9579 9.23048H45.9657Z"
            fill="url(#paint2_linear)"
          />
          <Path
            d="M44.6164 6.92307C45.891 6.92307 46.9242 5.88986 46.9242 4.61534C46.9242 3.34082 45.891 2.30762 44.6164 2.30762C43.3419 2.30762 42.3087 3.34082 42.3087 4.61534C42.3087 5.88986 43.3419 6.92307 44.6164 6.92307Z"
            fill="#EEEEEE"
          />
          <Path
            d="M44.6164 2.69419C45.828 2.69419 46.8164 3.62495 46.9126 4.80956C46.9165 4.74418 46.9242 4.68268 46.9242 4.6173C46.9242 3.34421 45.8895 2.30957 44.6164 2.30957C43.3434 2.30957 42.3087 3.34421 42.3087 4.6173C42.3087 4.68268 42.3126 4.74418 42.3203 4.80956C42.4164 3.62495 43.4049 2.69419 44.6164 2.69419Z"
            fill="white"
            fillOpacity="0.4"
          />
          <Path
            d="M46.9118 4.80762C46.8156 5.99223 45.8233 6.92299 44.6156 6.92299C43.4079 6.92299 42.4156 5.99223 42.3194 4.80762C42.3155 4.873 42.3079 4.9345 42.3079 4.99988C42.3079 6.27297 43.3425 7.30761 44.6156 7.30761C45.8887 7.30761 46.9233 6.27297 46.9233 4.99988C46.9233 4.9345 46.9195 4.873 46.9118 4.80762Z"
            fill="#212121"
            fillOpacity="0.1"
          />
          <Path
            d="M60 13.8462C60 11.8385 58.7154 10.1346 56.9231 9.50001V4.61536C56.9231 2.06541 54.8577 0 52.3077 0H7.69233C5.14229 0 3.07688 2.06541 3.07688 4.61536L3.08842 9.49225C1.29229 10.1231 0 11.8307 0 13.8462C0 14.0615 0.0154193 14.2731 0.0422954 14.4769L3.07688 33.8461L1.55003 53.5269C1.54236 53.6346 1.53848 53.7385 1.53848 53.8461C1.53848 56.3962 3.60389 58.4615 6.15385 58.4615H53.8461C56.3962 58.4615 58.4615 56.3961 58.4615 53.8461C58.4615 53.7385 58.4576 53.6346 58.45 53.5269L56.923 33.8461L59.9576 14.4769C59.9847 14.2731 60 14.0615 60 13.8462Z"
            fill="url(#paint3_radial)"
            fillOpacity="0.05"
          />
        </G>
        <Defs>
          <Pattern
            id="pattern0_gcal"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          ></Pattern>
          <LinearGradient
            id="paint0_linear_gcal"
            x1="17.0441"
            y1="20.1268"
            x2="42.2618"
            y2="45.3446"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#1A237E" stopOpacity="0.2" />
            <Stop offset="1" stopColor="#1A237E" stopOpacity="0.02" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear"
            x1="15.3462"
            y1="4.58424"
            x2="18.3382"
            y2="7.57626"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#212121" stopOpacity="0.2" />
            <Stop offset="1" stopColor="#212121" stopOpacity="0.02" />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear"
            x1="44.5765"
            y1="4.58867"
            x2="47.2001"
            y2="7.21225"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#212121" stopOpacity="0.2" />
            <Stop offset="1" stopColor="#212121" stopOpacity="0.02" />
          </LinearGradient>
          <RadialGradient
            id="paint3_radial"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(4.11953 1.29176) scale(77.0168)"
          >
            <Stop offset="0.33" stopColor="white" />
            <Stop offset="1" stopColor="white" stopOpacity="0" />
          </RadialGradient>
          <ClipPath id="clip0_gcal">
            <Rect width="60" height="58.4615" fill="white" />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
